<script setup>

    import { Switch } from '@headlessui/vue'

    const props = defineProps({
        modelValue: Boolean,
        default: false,
        palette: {
            type: String,
            default: 'green'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        }
    })

    const emit = defineEmits(['update:modelValue'])

</script>

<template>

    <Switch
        :disabled="props.disabled || props.readonly"
        :modelValue="props.modelValue"
        @update:modelValue="value => emit('update:modelValue', value)"
        :class="[
            'group relative inline-flex h-5 w-10 flex-shrink-0 items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2',
            {
                'pointer-events-none opacity-50': props.disabled,
                'pointer-events-none': props.readonly,
                'cursor-pointer': !props.disabled && !props.readonly,
            },
            !props.disabled ? {
                'focus:ring-lifeworx-green-700 focus:ring-offset-lifeworx-green-400' : props.palette === 'green',
                'focus:ring-lifeworx-blue-700 focus:ring-offset-lifeworx-blue-400' : props.palette === 'blue',
                'focus:ring-lifeworx-purple-700 focus:ring-offset-lifeworx-purple-400' : props.palette === 'purple'
            } : {}
        ]"
    >
        <span class="sr-only">Scope Toggle</span>
        <span
            aria-hidden="true"
            class="pointer-events-none absolute h-full w-full rounded-md bg-transparent"
            />
        <span
            aria-hidden="true"
                :class="[
                    props.modelValue ? '' : 'bg-gray-200',
                    !props.disabled ? {
                        'bg-lifeworx-green-400' : props.palette === 'green' && props.modelValue,
                        'bg-lifeworx-blue-700' : props.palette === 'blue' && props.modelValue,
                        'bg-lifeworx-purple-500' : props.palette === 'purple' && props.modelValue,
                    } : {},
                    !props.disabled && !props.readonly ? {
                        'group-hover:bg-lifeworx-green-600/50' : props.palette === 'green' && props.modelValue,
                        'group-hover:bg-lifeworx-green-500/50' : props.palette === 'green' && !props.modelValue,
                        'group-hover:bg-lifeworx-blue-600/50' : props.palette === 'blue' && props.modelValue,
                        'group-hover:bg-lifeworx-blue-500/50' : props.palette === 'blue' && !props.modelValue,
                        'group-hover:bg-lifeworx-purple-400/50' : props.palette === 'purple' && props.modelValue,
                        'group-hover:bg-lifeworx-purple-300/50' : props.palette === 'purple' && !props.modelValue
                    } : {},
                    'pointer-events-none absolute mx-auto h-4 w-9 rounded-full transition-colors duration-200 ease-in-out'
                ]"
            />
        <span
            aria-hidden="true"
            :class="[
                props.modelValue ? 'translate-x-5' : 'translate-x-0',
                'pointer-events-none absolute left-0 inline-block h-5 w-5 transform rounded-full border border-gray-200 bg-white shadow ring-0 transition-transform duration-200 ease-in-out'
            ]"
            />
    </Switch>

</template>
